import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import { EnvironmentService } from '@epicuro-next/platform/environment';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { selectEnableSlideListDeletion } from '@epicuro-next/state/product-list-state';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, shareReplay, tap } from 'rxjs/operators';

@Injectable()
export class IonicLoaderService {
  private renderer: Renderer2;

  private ionicUrl$ = this.environmentService.environmentSettings.pipe(
    map((value) => value?.ionicCdnUrl),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  private enableSlideListDeletion$ = this.store.pipe(
    select(selectEnableSlideListDeletion),
  );

  public isIonicScriptLoadedOnMobile$ = combineLatest([
    atxIsMobile$,
    this.enableSlideListDeletion$,
    this.ionicUrl$,
  ]).pipe(
    filter(
      ([isMobile, enableSlideListDeletion]) =>
        !!(isMobile && enableSlideListDeletion),
    ),
    map(([, , url]) => this.isIonicScriptExists(url)),
  );

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private store: Store,
    private rendererFactory: RendererFactory2,
    private environmentService: EnvironmentService,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  private isIonicScriptExists(ionicUrl: string) {
    return !!this.document.querySelector(`script[src="${ionicUrl}"]`);
  }

  public appendIonicScript(ionicUrl: string) {
    const script = this.renderer.createElement('script');
    script.src = ionicUrl;
    script.type = 'module';

    this.renderer.appendChild(this.document.head, script);
  }

  public initialize() {
    return combineLatest([
      this.ionicUrl$,
      this.isIonicScriptLoadedOnMobile$,
    ]).pipe(
      filter(([, isLoaded]) => !isLoaded),
      tap(([url]) => this.appendIonicScript(url)),
    );
  }
}
